<template>
  <template v-for="(c, index) in content" :key="index">
    <component :is="getResolvedComponent(c.type)" :content="c" />
  </template>
</template>

<script setup>
defineProps({
  content: {
    type: Array,
    default: () => [],
  },
});

const getResolvedComponent = (type) => {
  switch (type) {
    case 'text':
      return resolveComponent('ContentText');
    case 'heading':
      return resolveComponent('ContentHeading');
    case 'paragraph':
      return resolveComponent('ContentParagraph');
    case 'link':
      return resolveComponent('ContentLink');
    case 'quote':
      return resolveComponent('ContentQuote');
    case 'image':
      return resolveComponent('ContentImage');
    case 'code':
      return resolveComponent('ContentCode');
    case 'list':
      return resolveComponent('ContentList');
    default:
      return 'span';
  }
};
</script>

<style lang="scss" scoped></style>
